import { render } from "./SignForm.vue?vue&type=template&id=604940df"
import script from "./SignForm.vue?vue&type=script&lang=js"
export * from "./SignForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__